import { createPinia } from "pinia";

export function createStores() {
  return createPinia();
}
